<template>
  <div class="top-img">
    <img :src="require(`@/assets/img/bg/bg-mfitt-top-img.jpg`)" alt="" />
  </div>
</template>

<script>
export default {
  name: "MFITTIndexThumbnailDisp",
};
</script>

<style lang="scss">
/*特急券トップ*/
.ticket-romancecar .top-img {
  margin-bottom: 13px;
}
.ticket-romancecar .top-img img {
  width: 100vw;
  height: auto;
  /* background-position: 0 -40px; */
}
</style>
